import React from 'react';
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <div>
        <div id="plain"></div>
      <footer id="footer">
        <div className="footer-up">
          <div className="deals-1">
            <div className="right">
              <h5>Get Email Deals & Earn Cashback</h5>
              <input
                type="text"
                placeholder="enter email address..."
                id="email"
              />
              <span>
                <button id="footer-btn">sign Up</button>
              </span>
            </div>
            <p>Link to this page and tell all your friends</p>
          </div>
          <div className="deals-2">
            <p>
              About Us | Help | Accessibility Statement | Contact Us | Partner
              with us | Services | Country/Region | Connect | Own your Own Shop
              Site
            </p>
            <span>
              <i className="fas fa-envelope"></i>
              <i className="fab fa-facebook"></i>
              <i className="fab fa-twitter"></i>
              <i className="fab fa-pinterest"></i>
            </span>
          </div>
        </div>
        <div className="footer-down">
          <p>
            © 1997-2022 Market America, Inc. or its affiliates. All other
            designated trademarks, copyrights, and brands are the property of
            their respective owners.
          </p>
          <p>
            Only Customers will receive cashback on qualifying purchases.
            UnFranchise Owners/Shop Consultants will receive increased IBV
            instead of cashback on qualifying purchases.
          </p>
          <div className="policy">
            <Link to="">Policy</Link> | <Link to="#">Terms of Use</Link> |
            <Link to="">Advertising disclosure</Link> |
            <Link to="">Return Policy</Link> |
            <Link to="">Shipping Information</Link>
          </div>
          <hr />
          <div className="footer-images">
            <img src="https://www.shop.com/feo-cdn/A/A/pzI6tGZhU.webp" alt="" />
            <img src="https://www.shop.com/feo-cdn/z/b/qA5FJf0J4.webp" alt="" />
            <img src="https://www.shop.com/feo-cdn/q/B/9huVMYs4g.webp" alt="" />
            <img src="https://www.shop.com/feo-cdn/9/y/SggnBCF2o.webp" alt="" />
            <img src="https://www.shop.com/feo-cdn/p/Y/nOXdu76ik.webp" alt="" />
            <img src="https://www.shop.com/feo-cdn/u/P/cg2zbaz_s.webp" alt="" />
            <img src="https://www.shop.com/feo-cdn/K/F/E44Pe49Qs.webp" alt="" />
            <img src="https://www.shop.com/feo-cdn/T/P/ESOWP6gWY.webp" alt="" />
            <img src="https://www.shop.com/feo-cdn/T/P/ESOWP6gWY.webp" alt="" />
          </div>
          <div id="foot-img-last">
            <img src="./images/download.png" alt="" />
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer